export default "data:image/webp;base64,UklGRjIAAABXRUJQVlA4TCUAAAAvJ8AFACDMNsKZ2xmeZZ8CksT/rxoWCATSEEQcW9z//PhmvooPAA=="